
export const mapConfig = import.meta.env.VITE_MAP_MAPBOX;
export const googleAnalyticsConfig = import.meta.env.VITE_GA_MEASUREMENT_ID;
export const nomeProjeto = import.meta.env.VITE_NOME_PROJETO;
export const urlLogo = import.meta.env.VITE_LOGO_URL;
export const colorTheme = import.meta.env.VITE_COLOR_THEME;
const usuario = localStorage.getItem("usuarioId");
const numero = localStorage.getItem("numberId");
const pod = localStorage.getItem("pod");

// Determina se está em modo de desenvolvimento baseado no NODE_ENV
// NODE_ENV será 'development' quando executar npm run dev
// NODE_ENV será 'production' quando executar npm start
const isDevMode = import.meta.env.MODE === 'development';

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 50,
  DASHBOARD_DESKTOP_HEIGHT: 65,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 220,
  DASHBOARD_WIDTH: 200,
  DASHBOARD_COLLAPSE_WIDTH: 70,
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32
};

export default {
  dev: isDevMode,
  settings: {
    blockChannelUsage: false
  },
  urlBase: `https://api1-${usuario}.zapchat.app`,
  urlWhatsapp: `https://z${pod}.zindi.com.br`,
  urlMeta: `https://patagon.zindi.com.br`,
  urlApi: `https://api-${usuario}.zapchat.app`,
  numero: numero,
  url_dev: 'http://localhost:2000',
  api_dev: 'http://localhost:2000',
  url_prod: 'https://api.lais.app',
  api_prod: 'https://api.lais.app',
  urlBackend: 'https://api.lais.app',
  urlWs: 'https://ws.zindi.com.br',
  url_dev_ws: 'https://ws.zindi.com.br',
  url_dev_links: 'http://localhost:5173',
  url_prod_links: 'https://link.lais.app',
  //url_dev_ws: 'http://localhost:4000',
  //urlWs: 'http://localhost:4000',
  api_dev_integrations: 'http://localhost:3005',
  api_prod_integrations: 'https://integrations.lais.app',
  //urlWs:'http://localhost:4000',
  erroDesconexaoWhatsapp: {
    titulo: "Erro de conexão",
    mensagem: "A sessão com o whatsapp está desconetada, por favor reconecte o whatsapp"
  }

};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};


export const automationEvents = [
  {
    name: "Um campo de informação do lead no funil for atualizado",
    value: "from.funnel.card.field.change",
    category: "funil",
    icon: "mdi:pencil-outline", // Iconify icon
  },
  {
    name: "Um lead for criado",
    value: "from.funnel.card.create",
    category: "funil",
    icon: "mdi:plus-box-outline", // Iconify icon
  },
  {
    name: "Um lead sair de um estágio do funil",
    value: "from.funnel.card.out.stage",
    category: "funil",
    icon: "mdi:swap-horizontal-bold", // Iconify icon
  },
  {
    name: "Um lead entrar em um estágio do funil",
    value: "from.funnel.card.in.stage",
    category: "funil",
    icon: "mdi:swap-horizontal-bold", // Iconify icon
  },
  {
    name: "Um lead sair e entrar em um estágio do funil",
    value: "from.funnel.card.inOut.stage",
    category: "funil",
    icon: "mdi:swap-horizontal-bold", // Iconify icon
  },

  {
    name: "Um usuário aceitar uma conversa “em fila”",
    value: "from.chat.accept",
    category: "chat whatsapp",
    icon: "mdi:account-check-outline", // Iconify icon
  },
  {
    name: "Uma conversa foi finalizada",
    value: "from.chat.finish",
    category: "chat whatsapp",
    icon: "lets-icons:flag-finish-fill", // Iconify icon
  },
  {
    name: "Uma etiqueta(tag) for adicionada ou removida no chat",
    value: "from.chat.tag.inOut",
    category: "chat whatsapp",
    icon: "mingcute:tag-2-fill", // Iconify icon
  },

  {
    name: "Uma mensagem conter um gatilho ou contexto",
    value: "from.chat.contains",
    category: "chat whatsapp",
    ai: true,
    icon: "mdi:message-text-outline", // Iconify icon
  },
  {
    name: "Uma conversa for transferida para usuário ou setor",
    value: "from.chat.assign",
    category: "chat whatsapp",
    icon: "stash:target", // Iconify icon
  },
  {
    name: "Primeira mensagem de uma conversa",
    value: "from.chat.firstMessage",
    category: "chat whatsapp",
    icon: "bxs:message-error", // Iconify icon
  },
  {
    name: "Receber uma avaliação na conversa",
    value: "from.chat.feedback",
    category: "chat whatsapp",
    icon: "material-symbols:star-rounded", // Iconify icon
  },
  {
    name: "Um contato fazer aniversário",
    value: "from.jobs.birthdate",
    category: "rotina",
    icon: "material-symbols:cake", // Iconify icon
  },
  {
    name: "Houver Inatividade em uma conversa",
    value: "from.chat.inactivity",
    category: "rotina",
    icon: "basil:timer-solid", // Iconify icon
    alerts: []
  },
  {
    name: "Houver inatividade em um lead no estágio do funil",
    value: "from.funnel.card.inativity",
    category: "rotina",
    icon: "basil:timer-solid", // Iconify icon
    alerts: []
  },
  {
    name: "Resumo de conversas for realizado (BETA)",
    value: "from.chats.resume",
    category: "rotina",
    icon: "fe:magic", // Iconify icon
    alerts: []
  },
  // {
  //   name: "Receber evento externo",
  //   value: "from.trigger.event",
  //   category: "integrações",
  //   icon: "mdi:move-resize", // Iconify icon
  //   alerts: []
  // },
  {
    name: "Um chamado for criado",
    value: "from.chamado.create",
    category: "chamados",
    icon: "mdi:ticket-outline",
  },
  {
    name: "O status de um chamado mudar",
    value: "from.chamado.status.change",
    category: "chamados",
    icon: "mdi:swap-horizontal-bold",
  },
  {
    name: "Um chamado for concluído",
    value: "from.chamado.finish",
    category: "chamados",
    icon: "mdi:check-circle-outline",
  },
  {
    name: "Um comentário for adicionado no chamado",
    value: "from.chamado.comment",
    category: "chamados",
    icon: "mdi:comment-text-outline",
  },
  {
    name: "Uma resposta de formulário for enviada",
    value: "from.formulario.response.submit",
    category: "formularios",
    icon: "mdi:form-textbox",
  },
  {
    name: "Uma tarefa for criada",
    value: "from.tarefa.create",
    category: "tarefas",
    icon: "mdi:clipboard-plus-outline",
  },
  {
    name: "O status de uma tarefa mudar",
    value: "from.tarefa.status.change",
    category: "tarefas",
    icon: "mdi:swap-horizontal-bold",
  },
  {
    name: "Uma tarefa for concluída",
    value: "from.tarefa.finish",
    category: "tarefas",
    icon: "mdi:clipboard-check-outline",
  },
];

export const automationActions = [
  {
    name: "Mova um lead para um estágio do funil",
    value: "to.moveCardStage",
    icon: "mdi:move-resize",
    category: "funil",
    accepts: [
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.inactivity",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.finish",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
  },
  {
    name: "Faça uma ação no Lead",
    value: "to.funnel.action",
    icon: "mdi:form-textbox",
    category: "funil",
    alerts: [
      "Se não houver um card vinculado, esta ação será ignorada."
    ],
    accepts: [
      "from.chat.inactivity",
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "from.chat.contains",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.finish",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
  },
  {
    name: "Criar uma nota na conversa",
    value: "to.chat.addNote",
    icon: "mdi:note-text-outline",
    category: "chat whatsapp",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.finish",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
  },
  {
    name: "Crie um card",
    value: "to.funnel.cardCreate",
    icon: "mdi:card-outline",
    category: "funil",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "chat_palavra_chave",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.jobs.birthdate",
      "from.chat.finish",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
  },
  {
    name: "Adicionar Etiqueta ao chat",
    value: "to.chat.addTag",
    icon: "mdi:tag-outline",
    category: "chat whatsapp",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.jobs.birthdate",
      "from.chat.finish",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
    alerts: [
      "Caso não tenha um chat vinculado, esta ação será ignorada."
    ]
  },
  {
    name: "Remover Etiqueta do chat",
    value: "to.chat.removeTag",
    icon: "fluent:tag-off-24-filled",
    category: "chat whatsapp",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.tag.inOut",
      "from.chat.feedback",
      "from.jobs.birthdate",
      "from.chat.firstMessage",
      "from.chat.finish",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
    alerts: [
      "Caso não tenha um chat vinculado, esta ação será ignorada."
    ]
  },
  {
    name: "Enviar uma mensagem",
    value: "to.chat.sendMessage",
    icon: "uil:message",
    category: "chat whatsapp",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.funnel.card.create",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.jobs.birthdate",
      "from.chat.finish",
      "from.chats.resume",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
      "from.tarefa.create", "from.tarefa.status.change", "from.tarefa.finish"
    ],
    alerts: [
      "Caso não tenha um chat vinculado ao lead, esta ação será ignorada."
    ]
  },
  {
    name: "Finalizar a conversa",
    value: "to.chat.finish",
    icon: "lets-icons:flag-finish-fill",
    category: "chat whatsapp",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.funnel.card.create",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.jobs.birthdate",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
    alerts: []
  },
  {
    name: "Reabilitar bot no chat",
    value: "to.chat.enableBot",
    icon: "mdi:robot-outline",
    category: "chat whatsapp",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.funnel.card.create",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.jobs.birthdate",
      "from.chat.finish",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
    alerts: [
      "Caso não tenha um chat vinculado, esta ação será ignorada."
    ]
  },
  {
    name: "Transferir a conversa para um usuario ou setor",
    value: "to.chat.transfer",
    icon: "lucide:rotate-cw",
    category: "chat whatsapp",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.funnel.card.create",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.jobs.birthdate",
      "from.chat.finish",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
    alerts: []
  },
  {
    name: "Direcionar um chat",
    value: "to.chat.assign",
    icon: "carbon:flow",
    category: "chat whatsapp",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.funnel.card.create",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.jobs.birthdate",
      "from.chat.finish",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
    alerts: []
  },
  {
    name: "Transferir o lead para um usuário",
    value: "to.funnel.cardTransferUser",
    icon: "mdi:account-switch-outline",
    category: "funil",
    accepts: [
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "from.funnel.card.inOut.stage",
      "from.chat.tag.inOut",
      "from.chat.finish",
      "from.chat.accept",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
    ],
    alerts: [

    ]
  },
  {
    name: "Uma requisição HTTP",
    value: "to.httpRequest",
    icon: "mdi:web",
    category: "funções",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.jobs.birthdate",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.chat.finish",
      "from.chats.resume",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
      "from.tarefa.create", "from.tarefa.status.change", "from.tarefa.finish"
    ],
  },
  {
    name: "LLM",
    value: "to.ai.llm",
    icon: "mdi:robot-outline",
    category: "funções",
    accepts: [],
  },
  {
    name: "Agente",
    value: "to.ai.agent",
    icon: "mdi:face-agent",
    category: "funções",
    accepts: [],
  },
  {
    name: "Enviar para Make",
    value: "to.sendMake",
    icon: "simple-icons:make",
    category: "integrações",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.jobs.birthdate",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.chat.finish",
      "from.chats.resume",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
      "from.tarefa.create", "from.tarefa.status.change", "from.tarefa.finish"
    ],
  },
  {
    name: "Esperar",
    value: "to.wait",
    icon: "mdi:timer-sand",
    category: "lógica",
    accepts: [
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_palavra_chave",
      "chat_aceito",
      "from.chat.accept",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.inactivity",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.chat.finish",
      "from.chats.resume",
      "from.jobs.birthdate",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
      "from.tarefa.create", "from.tarefa.status.change", "from.tarefa.finish"
    ],
    alerts: ["As ações após esta serão executadas após o tempo de espera definido."]
  },
  {
    name: "Condição (Se/Senão)",
    value: "to.condition",
    icon: "mdi:source-branch",
    category: "lógica",
    accepts: [
      "from.funnel.card.inOut.stage",
      "from.funnel.card.field.change",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_palavra_chave",
      "chat_aceito",
      "from.chat.accept",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.inactivity",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.chat.finish",
      "from.chats.resume",
      "from.jobs.birthdate",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
      "from.tarefa.create", "from.tarefa.status.change", "from.tarefa.finish"
    ],
  },
];


export const conditionFieldsByTrigger = {
  // Chat triggers
  "from.chat.contains": [
    { key: "messageText", label: "Mensagem recebida", type: "String", category: "Chat" },
    { key: "chatStatus", label: "Status do chat", type: "String", category: "Chat" },
    { key: "numero", label: "Número do contato", type: "String", category: "Contato" },
    { key: "nome", label: "Nome do contato", type: "String", category: "Contato" },
    { key: "fromMe", label: "Enviada por mim", type: "Boolean", category: "Chat" },
  ],
  "from.chat.firstMessage": [
    { key: "messageText", label: "Mensagem recebida", type: "String", category: "Chat" },
    { key: "numero", label: "Número do contato", type: "String", category: "Contato" },
    { key: "nome", label: "Nome do contato", type: "String", category: "Contato" },
    { key: "chatStatus", label: "Status do chat", type: "String", category: "Chat" },
  ],
  "from.chat.accept": [
    { key: "user_id", label: "Usuário que aceitou", type: "String", category: "Usuário" },
    { key: "numero", label: "Número do contato", type: "String", category: "Contato" },
    { key: "nome", label: "Nome do contato", type: "String", category: "Contato" },
    { key: "chatStatus", label: "Status do chat", type: "String", category: "Chat" },
  ],
  "from.chat.assign": [
    { key: "numero", label: "Número do contato", type: "String", category: "Contato" },
    { key: "nome", label: "Nome do contato", type: "String", category: "Contato" },
    { key: "chatStatus", label: "Status do chat", type: "String", category: "Chat" },
  ],
  "from.chat.inactivity": [
    { key: "numero", label: "Número do contato", type: "String", category: "Contato" },
    { key: "nome", label: "Nome do contato", type: "String", category: "Contato" },
    { key: "chatStatus", label: "Status do chat", type: "String", category: "Chat" },
  ],
  "from.chat.tag.inOut": [
    { key: "numero", label: "Número do contato", type: "String", category: "Contato" },
    { key: "nome", label: "Nome do contato", type: "String", category: "Contato" },
    { key: "chatStatus", label: "Status do chat", type: "String", category: "Chat" },
  ],
  "from.chat.feedback": [
    { key: "chatFeedback", label: "Nota do feedback", type: "Number", category: "Chat" },
    { key: "messageText", label: "Mensagem do feedback", type: "String", category: "Chat" },
    { key: "numero", label: "Número do contato", type: "String", category: "Contato" },
    { key: "nome", label: "Nome do contato", type: "String", category: "Contato" },
  ],
  "from.chat.finish": [
    { key: "numero", label: "Número do contato", type: "String", category: "Contato" },
    { key: "nome", label: "Nome do contato", type: "String", category: "Contato" },
    { key: "chatStatus", label: "Status do chat", type: "String", category: "Chat" },
  ],

  // Funnel triggers
  "from.funnel.card.field.change": [
    { key: "estagio_pipeline_id", label: "ID do estágio atual", type: "String", category: "Funil" },
    { key: "usuario_id", label: "Usuário responsável", type: "String", category: "Usuário" },
  ],
  "from.funnel.card.create": [
    { key: "usuario_id", label: "Usuário responsável", type: "String", category: "Usuário" },
  ],
  "from.funnel.card.out.stage": [
    { key: "past_stage_id", label: "Estágio anterior", type: "String", category: "Funil" },
    { key: "usuario_id", label: "Usuário responsável", type: "String", category: "Usuário" },
  ],
  "from.funnel.card.in.stage": [
    { key: "new_stage_id", label: "Novo estágio", type: "String", category: "Funil" },
    { key: "usuario_id", label: "Usuário responsável", type: "String", category: "Usuário" },
  ],
  "from.funnel.card.inOut.stage": [
    { key: "past_stage_id", label: "Estágio anterior", type: "String", category: "Funil" },
    { key: "new_stage_id", label: "Novo estágio", type: "String", category: "Funil" },
    { key: "usuario_id", label: "Usuário responsável", type: "String", category: "Usuário" },
  ],
  "from.funnel.card.inativity": [
    { key: "usuario_id", label: "Usuário responsável", type: "String", category: "Usuário" },
  ],

  // Chamado triggers
  "from.chamado.create": [
    { key: "tipo", label: "Tipo do chamado", type: "String", category: "Chamado" },
    { key: "direcionado_para", label: "Direcionado para", type: "String", category: "Chamado" },
  ],
  "from.chamado.status.change": [
    { key: "tipo", label: "Tipo do chamado", type: "String", category: "Chamado" },
    { key: "new_status", label: "Novo status", type: "String", category: "Chamado" },
    { key: "direcionado_para", label: "Direcionado para", type: "String", category: "Chamado" },
  ],
  "from.chamado.finish": [
    { key: "tipo", label: "Tipo do chamado", type: "String", category: "Chamado" },
    { key: "direcionado_para", label: "Direcionado para", type: "String", category: "Chamado" },
  ],
  "from.chamado.comment": [
    { key: "tipo", label: "Tipo do chamado", type: "String", category: "Chamado" },
    { key: "direcionado_para", label: "Direcionado para", type: "String", category: "Chamado" },
  ],

  // Formulario
  "from.formulario.response.submit": [
    { key: "formulario_id", label: "ID do formulário", type: "String", category: "Formulário" },
  ],

  // Tarefa triggers
  "from.tarefa.create": [
    { key: "assigned_to", label: "Responsável", type: "String", category: "Tarefa" },
  ],
  "from.tarefa.status.change": [
    { key: "new_status", label: "Novo status", type: "String", category: "Tarefa" },
    { key: "assigned_to", label: "Responsável", type: "String", category: "Tarefa" },
  ],
  "from.tarefa.finish": [
    { key: "assigned_to", label: "Responsável", type: "String", category: "Tarefa" },
  ],
};

export const chatflowActions = [
  {
    name: "Mova um lead para um estágio do funil",
    value: "to.moveCardStage",
    icon: "mdi:move-resize",
    category: "funil",
    accepts: [],
  },
  {
    name: "Faça uma ação no Lead",
    value: "to.funnel.action",
    icon: "mdi:form-textbox",
    category: "funil",
    alerts: [
      "Se não houver um card vinculado, esta ação será ignorada."
    ],
    accepts: [],
  },
  {
    name: "Criar uma nota na conversa",
    value: "to.chat.addNote",
    icon: "mdi:note-text-outline",
    category: "chat whatsapp",
    accepts: [],
  },
  {
    name: "Crie um card",
    value: "to.funnel.cardCreate",
    icon: "mdi:card-outline",
    category: "funil",
    accepts: [],
  },
  {
    name: "Adicionar Etiqueta ao chat",
    value: "to.chat.addTag",
    icon: "mdi:tag-outline",
    category: "chat whatsapp",
    accepts: [],
    alerts: [
      "Caso não tenha um chat vinculado, esta ação será ignorada."
    ]
  },
  {
    name: "Remover Etiqueta do chat",
    value: "to.chat.removeTag",
    icon: "fluent:tag-off-24-filled",
    category: "chat whatsapp",
    accepts: [],
    alerts: [
      "Caso não tenha um chat vinculado, esta ação será ignorada."
    ]
  },
  {
    name: "Enviar uma mensagem",
    value: "to.chat.sendMessage",
    icon: "uil:message",
    category: "chat whatsapp",
    accepts: [],
    alerts: [
      "Caso não tenha um chat vinculado ao lead, esta ação será ignorada."
    ]
  },
  {
    name: "Finalizar a conversa",
    value: "to.chat.finish",
    icon: "lets-icons:flag-finish-fill",
    category: "chat whatsapp",
    accepts: [],
    alerts: []
  },
  {
    name: "Reabilitar bot no chat",
    value: "to.chat.enableBot",
    icon: "mdi:robot-outline",
    category: "chat whatsapp",
    accepts: [],
    alerts: [
      "Caso não tenha um chat vinculado, esta ação será ignorada."
    ]
  },
  {
    name: "Transferir a conversa para um usuario ou setor",
    value: "to.chat.transfer",
    icon: "lucide:rotate-cw",
    category: "chat whatsapp",
    accepts: [],
    alerts: []
  },
  {
    name: "Direcionar um chat",
    value: "to.chat.assign",
    icon: "carbon:flow",
    category: "chat whatsapp",
    accepts: [],
    alerts: []
  },
  {
    name: "Transferir o lead para um usuário",
    value: "to.funnel.cardTransferUser",
    icon: "mdi:account-switch-outline",
    category: "funil",
    accepts: [],
    alerts: [

    ]
  },
  {
    name: "Uma requisição HTTP",
    value: "to.httpRequest",
    icon: "mdi:web",
    category: "funções",
    accepts: [
      "from.chat.inactivity",
      "from.chat.accept",
      "from.funnel.card.inOut.stage",
      "from.jobs.birthdate",
      "from.funnel.card.field.change",
      "chat_palavra_chave",
      "from.funnel.card.create",
      "from.funnel.card.out.stage",
      "from.funnel.card.in.stage",
      "from.funnel.card.inativity",
      "chat_aceito",
      "from.chat.assign",
      "from.chat.contains",
      "from.chat.tag.inOut",
      "from.chat.firstMessage",
      "from.chat.feedback",
      "from.chat.finish",
      "from.chats.resume",
      "from.chamado.create", "from.chamado.status.change", "from.chamado.finish", "from.chamado.comment",
      "from.formulario.response.submit",
      "from.tarefa.create", "from.tarefa.status.change", "from.tarefa.finish"
    ],
  },
  {
    name: "LLM",
    value: "to.ai.llm",
    icon: "mdi:robot-outline",
    category: "ia",
    accepts: [],
  },
  {
    name: "Agente",
    value: "to.ai.agent",
    icon: "mdi:face-agent",
    category: "ia",
    accepts: [],
  },
  { name: 'Perguntar', value: 'ask_question', icon: 'mdi:help-circle-outline', category: 'Interação' },
  { name: 'Condição', value: 'condition', icon: 'mdi:call-split', category: 'Lógica' },
  { name: 'Pular para', value: 'jump', icon: 'mdi:arrow-right-bold-circle-outline', category: 'Lógica' }
];